import { gql } from '@apollo/client';

export const reevaluateCartDiscountsMutation = gql`
  mutation ReevaluateCartDiscounts($locale: Locale!, $cartType: CartType!, $zipCode: String) {
    reevaluateCartDiscounts(locale: $locale, cartType: $cartType, zipCode: $zipCode) {
      cart {
        id
      }
    }
  }
`;
